import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export interface StudentWithoutDocument {
  id: number
  document: string | null
  birth_date: string
  fantasy_name: string
  gender: string
  period: string
  document_type: string
  number_document: string
  reservationsChild: Array<{
    id: number
    document_required_mail_sent_at: string | null
  }>
  parentClients: {
    id: number
    fantasy_name: string
    email: string
    phone: string | null
    cell_phone: string | null
  }
}

export const notifyMissingDocumentByActivity = async (
  activityId: string,
): Promise<void> => {
  try {
    await apiInstance.post(
      ENDPOINTS.STUDENTS.NOTIFY_MISSING_DOCUMENT_BY_ACTIVITY(activityId),
    )
  } catch (error) {
    const axiosError = error as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const listWithoutDocumentByActivity = async (
  activityId: string,
): Promise<StudentWithoutDocument[]> => {
  try {
    const response = await apiInstance.get<StudentWithoutDocument[]>(
      ENDPOINTS.STUDENTS.LIST_WITHOUT_DOCUMENT_BY_ACTIVITY(activityId),
    )
    return response.data
  } catch (error) {
    const axiosError = error as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
